import { type ReactNode } from 'react';
import { DisclaimerText } from '@/styles';
import FullScreenOverlay from '../FullScreenOverlay/FullScreenOverlay';
import OverlayHeader from '../FullScreenOverlay/OverlayHeader';
import PriceBreakdownTable, {
  PriceBreakdownTableProps,
} from '../PriceBreakdownTable/PriceBreakdownTable';
import VehicleCardDropdownText, {
  VehicleCardDropdownTextProps,
} from './VehicleCardDropdownText';

interface VehicleCardMobilePriceOverlayProps
  extends VehicleCardDropdownTextProps {
  priceBreakdown: PriceBreakdownTableProps;
  disclaimerText: ReactNode;
  onClose: () => void;
}

const VehicleCardMobilePriceOverlay = ({
  priceBreakdown,
  disclaimerText,
  onClose,
  ...restProps
}: VehicleCardMobilePriceOverlayProps) => (
  <FullScreenOverlay
    header={
      <OverlayHeader handleClose={onClose}>
        <VehicleCardDropdownText {...restProps} />
      </OverlayHeader>
    }
  >
    <PriceBreakdownTable {...priceBreakdown} />
    <DisclaimerText>{disclaimerText}</DisclaimerText>
  </FullScreenOverlay>
);

export default VehicleCardMobilePriceOverlay;
